import { render } from "./FolderView.vue?vue&type=template&id=dd5324b6&scoped=true"
import script from "./FolderView.vue?vue&type=script&lang=js"
export * from "./FolderView.vue?vue&type=script&lang=js"

import "./FolderView.vue?vue&type=style&index=0&id=dd5324b6&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd5324b6"]])

export default __exports__